import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import ParticleCanvas from "../../login/components/ParticleCanvas";

const ACCENT = "#04aec1";
const ACCENT_MID = "#6366f1";

const PageHero = ({
  eyebrow,
  title,
  subtitle,
  height = 460,
  children,
}) => (
  <Box
    as="section"
    position="relative"
    overflow="hidden"
    minH={`${height}px`}
    display="flex"
    alignItems="center"
    bg={`linear-gradient(160deg, ${ACCENT}, ${ACCENT_MID})`}
    color="white"
    px={{ base: "20px", md: "28px" }}
    pt={{ base: "48px", md: "64px" }}
    pb={{ base: "56px", md: "72px" }}
  >
    {/* Wave overlay */}
    <Box
      position="absolute"
      inset={0}
      pointerEvents="none"
      sx={{
        backgroundImage: "url('/navbar_bg.png')",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        opacity: 0.4,
        mixBlendMode: "screen",
      }}
    />

    {/* Particle field */}
    <ParticleCanvas tint="#ffffff" density={1.0} link={130} />

    {/* Vignette */}
    <Box
      position="absolute"
      inset={0}
      pointerEvents="none"
      sx={{
        background:
          "radial-gradient(ellipse at 30% 50%, rgba(0,0,0,0.22), transparent 60%)",
      }}
    />

    <Flex
      position="relative"
      zIndex={2}
      direction="column"
      gap="20px"
      maxW="1280px"
      width="100%"
      mx="auto"
    >
      {eyebrow && (
        <Box
          alignSelf="flex-start"
          display="inline-flex"
          fontSize="11px"
          fontWeight={700}
          letterSpacing="0.16em"
          textTransform="uppercase"
          padding="5px 12px"
          borderRadius="9999px"
          bg="rgba(255,255,255,0.16)"
          border="1px solid rgba(255,255,255,0.30)"
          backdropFilter="blur(8px)"
          color="white"
        >
          {eyebrow}
        </Box>
      )}

      <Heading
        as="h1"
        m={0}
        fontSize={{ base: "36px", md: "44px", lg: "56px" }}
        lineHeight="1.05"
        letterSpacing="-0.025em"
        fontWeight={700}
        maxW="820px"
        sx={{ textShadow: "0 2px 12px rgba(0,0,0,0.18)" }}
      >
        {title}
      </Heading>

      {subtitle && (
        <Text
          m={0}
          fontSize={{ base: "16px", md: "18px" }}
          lineHeight="1.5"
          color="rgba(255,255,255,0.9)"
          maxW="640px"
          fontWeight={400}
        >
          {subtitle}
        </Text>
      )}

      {children}
    </Flex>
  </Box>
);

export default PageHero;
